import { normalizeDocumentRequest } from '../utils/cnpj-payload';
import axios from "axios";
import { attachSessionToken } from "./auth-header";

import loginService from "./Login.Service";
import defaultService from "./Default.Service";
import uploadService from "./Upload.Service";
import perfilService from "./Perfil.Service";
import usersService from "./Users.Service";
import cepService from "./CEP.Service";
import simulationsService from "./Simulations.Service";
import solicitationsService from "./Solicitations.Service";
import logsService from "./Logs.Service";
import situationsService from "./Situations.Service";
import howService from "./How.Service";
import reasonsService from "./Reasons.Service";
import projectsService from "./Projects.Service";
import solicitationCommentsService from "./SolicitationComments.Service";
import boaVistaService from "./BoaVista.Service";
import dashboardService from "./Dashboard.Service";
import profileService from "./Profile.Service";
import clientService from "./Clients.Service";
import companyService from "./Company.Service";
import analizeOperationService from "./AnalizeOperation.Service";
import negativeService from "./Negative.Service";
import * as Actions from "../redux/constants/Auth";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT_URL,
});

console.log(process.env.REACT_APP_API_MIND_ENDPOINT_URL)
const apiMind = axios.create({
  baseURL: process.env.REACT_APP_API_MIND_ENDPOINT_URL,
});

export const getAuthToken = () => {
  return localStorage.getItem(Actions.AUTH_TOKEN);
};

const attachAuthToken = (config) => attachSessionToken(config, getAuthToken());

const attachBearerAuthToken = (config) => {
  const token = getAuthToken();
  if (token) {
    const value = token.startsWith("Bearer ") ? token : `Bearer ${token}`;
    config.headers["Authorization"] = value;
  }
  return config;
};

api.interceptors.request.use(attachAuthToken, (error) => Promise.reject(error));
apiMind.interceptors.request.use(attachBearerAuthToken, (error) => Promise.reject(error));

api.interceptors.request.use(normalizeDocumentRequest);
apiMind.interceptors.request.use(normalizeDocumentRequest);

export {
  api,
  apiMind,
  loginService,
  defaultService,
  uploadService,
  perfilService,
  usersService,
  cepService,
  simulationsService,
  solicitationsService,
  logsService,
  situationsService,
  howService,
  reasonsService,
  projectsService,
  solicitationCommentsService,
  boaVistaService,
  dashboardService,
  negativeService,
  profileService,
  clientService,
  companyService,
  analizeOperationService,
};
